import "./App.css";
import FormPage from "./pages/form";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SuccessFulSubmission from "./pages/successful-submission";
import ClinicRegistrationPage from "./pages/clinic-registration";
import TherapistRegistrationPage from "./pages/therapist-registration";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FormPage />} />
        <Route path="/clinic" element={<ClinicRegistrationPage />} />
        <Route path="/therapist" element={<TherapistRegistrationPage />} />
        <Route
          path="/successful-submission"
          element={<SuccessFulSubmission />}
        />
      </Routes>
    </Router>
  );
}

export default App;
